export enum CustomCommandActionType {
  OPEN_MODAL = 'openModal',
  CLEAR = 'clear'
}
